import { Link } from 'react-router-dom'
import { styled } from 'styled-system/jsx'

const Footer = styled('footer', {
  base: {
    backgroundColor: 'app.surface',
    borderTop: '1px solid',
    borderColor: 'app.border',
    paddingY: { base: '40px', md: '56px' },
    paddingX: { base: '16px', md: '32px' },
  },
})

const FooterInner = styled('div', {
  base: {
    maxWidth: '1180px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: { base: '1fr', md: '1.4fr 1fr 1fr 1fr' },
    gap: { base: '32px', md: '40px' },
    alignItems: 'start',
  },
})

const BrandColumn = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const BrandLine = styled('div', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: 700,
    color: 'app.fg',
    letterSpacing: '-0.01em',
  },
})

const BrandBlurb = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    lineHeight: 1.55,
    color: 'app.fgMuted',
    maxWidth: '320px',
    margin: 0,
  },
})

const ColumnHeader = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: '12px',
  },
})

const ColumnList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const InternalLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fg',
    textDecoration: 'none',
    transition: 'color 160ms',
    _hover: { color: 'app.accent', textDecoration: 'none' },
  },
})

const ExternalLink = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fg',
    textDecoration: 'none',
    transition: 'color 160ms',
    _hover: { color: 'app.accent', textDecoration: 'none' },
  },
})

const LegalRow = styled('div', {
  base: {
    maxWidth: '1180px',
    margin: '32px auto 0',
    paddingTop: '24px',
    borderTop: '1px solid',
    borderColor: 'app.border',
    display: 'flex',
    flexDirection: { base: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { base: 'flex-start', md: 'center' },
    gap: '12px',
  },
})

const Copyright = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'app.fgMuted',
  },
})

const LegalLinks = styled('div', {
  base: {
    display: 'flex',
    gap: '20px',
  },
})

const LegalLink = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'app.fgMuted',
    textDecoration: 'none',
    _hover: { color: 'app.fg', textDecoration: 'none' },
  },
})

export {
  Footer,
  FooterInner,
  BrandColumn,
  BrandLine,
  BrandBlurb,
  ColumnHeader,
  ColumnList,
  InternalLink,
  ExternalLink,
  LegalRow,
  Copyright,
  LegalLinks,
  LegalLink,
}
